module.exports = __webpack_public_path__ + "img/gui_dishui.bf185e2f.png";